import { useState, useEffect } from "react";
import Loading from "../components/loading";
import { BrowserRouter, useNavigate, Route, Routes } from "react-router-dom";
import AppSettings from "./tabs/appSettings/appSettings";
import { ImUser } from "react-icons/im";
import { FiSettings, FiUser } from "react-icons/fi";
import { FaTachometerAlt, FaChartArea, FaDollarSign, FaList, FaCashRegister } from "react-icons/fa";
import Celebs from "./tabs/celebs/celebs";
import Users from "./tabs/users/users";
import Dashboard from "./tabs/dashboard/dashboard";
import Reports from "./tabs/reports/reports";
import Payments from "./tabs/payments/payments";
import Requests from "./tabs/requests/requests";
import { getDoc, getFirestore, doc, onSnapshot } from "firebase/firestore";
import Promos from "./tabs/promos/Promos";


const pages = [
    <Dashboard />,
    <Users />,
    <Celebs />,
    <AppSettings />,
    <Reports />,
    <Payments />,
    <Requests />,
    <Promos/>
];

export default function HomePage() {

    const db = getFirestore();
    let navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState("none");
    const [allowedPages, setAllowedPages] = useState({});


    useEffect(
        async () => {
            console.log(localStorage.getItem("authorized"));

            if (localStorage.getItem('authorized') === "true") {
                var email = localStorage.getItem("user");

                var subscribe= onSnapshot(doc(db,"admin",email),(doc)=>{
                    if(doc.exists()){
                        setCurrentPage("");
                        setAllowedPages(doc.data()["pages"]);
                        setLoading(false);
                    }
                    else{
                        navigate("/login")
                    }
                });
                
                
            }
            else {
                navigate("/login")
            }

            return function(){
                subscribe();
            }
        }, []
    );



    return (
        <div style={{ fontFamily: 'Montserrat' }} className='h-screen w-screen flex flex-row bg-gray-900'>

            {
                loading === true ?
                    <Loading /> :
                    <div className="z-0 absolute h-screen w-full flex">

                        <div style={{ fontFamily: 'Montserrat' }} className="bg-white/10 h-full w-1/5 flex flex-col">


                            {allowedPages["dashboard"] == true ? <button onClick={() => { setCurrentPage(0) }} className="hover:bg-blue-900 bg-white/10 text-white rounded-sm shadow-xl p-2 text-sm  m-2 text-left pl-12 flex flex-row items-center gap-2">
                                <FaTachometerAlt size={24} />
                                Dashboard
                            </button> : ""}

                            {allowedPages["users"]==true?
                                <button onClick={() => { setCurrentPage(1) }} className="hover:bg-blue-900 bg-white/10 text-white rounded-sm shadow-xl p-2 text-sm  m-2 text-left pl-12 flex flex-row items-center gap-2">
                                    <FiUser size={24} />
                                    Users
                                </button>:""
                            }


                            {allowedPages["celebs"]==true?
                                <button onClick={() => { setCurrentPage(2) }} className="hover:bg-blue-900 bg-white/10 text-white rounded-sm shadow-xl p-2 text-sm  m-2 text-left pl-12 flex items-center flex-row gap-2">
                                <ImUser size={24} />
                                Celebrities
                            </button>:""
                            }

                            {allowedPages["settings"]==true?
                                <button onClick={() => { setCurrentPage(3) }} className="hover:bg-blue-900 bg-white/10 text-white rounded-sm shadow-xl p-2 text-sm  m-2 text-left pl-12 flex flex-row items-center gap-2">
                                <FiSettings size={24} />
                                App Settings
                            </button>:""
                            }

                            {allowedPages["reports"]==true?
                                <button onClick={() => { setCurrentPage(4) }} className="hover:bg-blue-900 bg-white/10 text-white rounded-sm shadow-xl p-2 text-sm  m-2 text-left pl-12 flex flex-row items-center gap-2">
                                <FaChartArea size={24} />
                                Reports
                            </button>:""
                            }

                            {allowedPages["payments"]==true?<a onClick={() => { 
                                    window.open("https://dashboard.paystack.com/#/transactions?status=success&use_cursor=true", "_blank") //to open new page
                                }} className="hover:bg-blue-900 bg-white/10 text-white rounded-sm shadow-xl p-2 text-sm  m-2 text-left pl-12 flex flex-row items-center gap-2">
                                <FaDollarSign size={24} />
                                Payments
                            </a>:""}


                            {allowedPages["withdrawls"]==true?<a onClick={() => { 
                                    window.open("https://dashboard.paystack.com/#/transfers?use_cursor=true", "_blank") //to open new page
                                }} className="hover:bg-blue-900 bg-white/10 text-white rounded-sm shadow-xl p-2 text-sm  m-2 text-left pl-12 flex flex-row items-center gap-2">
                                <FaDollarSign size={24} />
                                Withdrawls
                            </a>:""}

                            {allowedPages["requests"]==true?
                                <button onClick={() => { setCurrentPage(6) }} className="hover:bg-blue-900 bg-white/10 text-white rounded-sm shadow-xl p-2 text-sm  m-2 text-left pl-12 flex flex-row items-center gap-2">
                                <FaList size={24} />
                                Requests
                            </button>:""
                            }


                            
                            {allowedPages["promos"]==true?
                                <button onClick={() => { setCurrentPage(7) }} className="hover:bg-blue-900 bg-white/10 text-white rounded-sm shadow-xl p-2 text-sm  m-2 text-left pl-12 flex flex-row items-center gap-2">
                                <FaCashRegister size={24} />
                                Promos
                            </button>:""
                            }



                        </div>

                        <div className="bg-black/20 h-full w-4/5 text-white overflow-scroll">
                            {pages[currentPage]}
                        </div>

                    </div>
            }

        </div>
    )
}
